/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateHouseholdMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateHouseholdInput;
}>;


export type UpdateHouseholdMutation = { __typename?: 'Mutation', updateHousehold: { __typename?: 'Household', spouseOrPartner: boolean, childrenOrPlanTo: boolean, buyingOrOwningHome: boolean, annualIncome: number, spouseAnnualIncome: number, spousalQuotesRequested: boolean | null } | null };


export const UpdateHouseholdDocument = gql`
    mutation UpdateHousehold($input: UpdateHouseholdInput!) {
  updateHousehold(input: $input) {
    spouseOrPartner
    childrenOrPlanTo
    buyingOrOwningHome
    annualIncome
    spouseAnnualIncome
    spousalQuotesRequested
  }
}
    `;
export type UpdateHouseholdMutationFn = Apollo.MutationFunction<UpdateHouseholdMutation, UpdateHouseholdMutationVariables>;
export function useUpdateHouseholdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHouseholdMutation, UpdateHouseholdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHouseholdMutation, UpdateHouseholdMutationVariables>(UpdateHouseholdDocument, options);
      }
export type UpdateHouseholdMutationHookResult = ReturnType<typeof useUpdateHouseholdMutation>;
export type UpdateHouseholdMutationResult = Apollo.MutationResult<UpdateHouseholdMutation>;
export type UpdateHouseholdMutationOptions = Apollo.BaseMutationOptions<UpdateHouseholdMutation, UpdateHouseholdMutationVariables>;